import { Injectable } from '@angular/core';
import { Submission } from '../models/submission.model';

@Injectable({
  providedIn: 'root'
})
export class SubmissionService {

  submissionTabs: Submission[] = [];
  activeSubmissionTabIndex: number = 0;
  activeSubmission!: Submission;

  constructor() { }


  activateSubmission(item: Submission) : number{
    const targetId = (item as any)?.SUBMISSION_ID;
    let tabIndex = this.submissionTabs.findIndex(
      (sub: Submission) => this.sameSubmissionId((sub as any)?.SUBMISSION_ID, targetId)
        );

    if(tabIndex === -1){
      this.submissionTabs.push(item);
      this.activeSubmissionTabIndex = this.submissionTabs.length;
      this.activeSubmission = item;
    }else{
      this.activeSubmissionTabIndex = tabIndex + 1;//+1 to exclude submissions tab
      this.activeSubmission = this.submissionTabs[tabIndex];
    }

    return this.activeSubmissionTabIndex;
  }
  activateSubmissionByIndex(index: number) : void{
    // index 0 = "Submission List" tab (no submission to activate). Previously
    // this method early-returned for index 0, leaving `activeSubmissionTabIndex`
    // stuck at the previously-active value. That caused
    // `SubmissionDataComponent`'s constructor (which reads this on every
    // cross-config navigation, e.g. closing the last submission tab → /list)
    // to blindly seed `selectedTab` with the stale index — even when
    // `submissionTabs` had been emptied. The result was a blank page (neither
    // the list pane nor any submission pane mounted) until the user manually
    // clicked the "Submission List" anchor. Reset the singleton state so the
    // recreated component lands on the list pane on first paint.
    if (index === 0) {
      this.activeSubmissionTabIndex = 0;
      this.activeSubmission = null as any;
      return;
    }
    if (index < 0 || index > this.submissionTabs.length) return;
    this.activeSubmissionTabIndex = index;
    this.activeSubmission = this.submissionTabs[index - 1];
  }

  private sameSubmissionId(left: any, right: any): boolean {
    if (left === undefined || left === null || right === undefined || right === null) {
      return false;
    }
    return Number(left) === Number(right) || String(left) === String(right);
  }
}
